import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-dialog',
  template: `
    <div class="flex overflow dialog aid-layout-column">
      <div
        class="dialog__header aid-layout-row aid-layout-align-space-between-center"
      >
        <div class="mat-headline-6 dialog__header--color">
          {{ title | translate | sentancecase }}
        </div>
        @if (closeButton) {
          <button [autofocus]="false" mat-icon-button (click)="close.emit()">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        }
      </div>
      @if (divider) {
        <mat-divider></mat-divider>
      }

      <div class="dialog__container">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DialogComponent implements OnInit {
  @Input() title?: string;
  @Input() divider = true;
  @Input() closeButton = true;
  @Output() close: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
